import React from 'react';

import { Button, Link } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';

import { NotificationRecord } from '~/services/SailthruService';

import dateFormatter from '~/utils/dateFormatter';

const sharedOpts: Partial<GridColDef> = {
  editable: false,
  sortable: false,
  filterable: false,
  hideable: false,
  disableColumnMenu: true,
  flex: 1,
};

function getColumns(): Array<GridColDef<NotificationRecord>> {
  return [
    {
      field: 'notification_id',
      headerName: 'Email ID',
      ...sharedOpts,
    },
    {
      field: 'created_at',
      headerName: 'Time Sent',
      renderCell: (params) => dateFormatter(params.row.created_at),
      ...sharedOpts,
    },
    {
      field: 'businessId',
      headerName: 'Business ID',
      renderCell: (params) => {
        const businessId = params.row.template_params?.businessId;
        if (!businessId) {
          return '-';
        }
        return (
          <Link href={`/lebusiness/${businessId}/business`} underline="hover">
            {String(businessId)}
          </Link>
        );
      },
      ...sharedOpts,
    },
    {
      field: 'businessName',
      headerName: 'Business Name',
      renderCell: (params) => String(params.row.template_params?.businessName ?? '-'),
      ...sharedOpts,
    },
    {
      field: 'email',
      headerName: 'Email',
      ...sharedOpts,
    },
    {
      field: 'employeeFirstName',
      headerName: 'Recipient Name',
      renderCell: (params) => String(params.row.template_params?.employeeFirstName ?? '-'),
      ...sharedOpts,
    },
    {
      field: 'operation',
      headerName: 'Operation',
      display: 'flex',
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            href={`/email/render?id=${params.row.notification_id}`}
            target="_blank"
          >
            View
          </Button>
        );
      },
      ...sharedOpts,
    },
  ];
}

export default getColumns;
